import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <>
      <section
        className="hero-section ptb-100 background-img full-screen"
        style={{
          background:
            "url('assets/img/app-hero-bg.jpg')no-repeat center center / cover",
        }}
      >
        <div className="container">
          <div className="row align-items-center justify-content-center">
            <div className="col-md-9 col-lg-7">
              <div className="error-content text-center text-white">
                <div className="notfound-404">
                  <h1 className="text-white">404</h1>
                </div>
                <h3 className="text-white">Lo siento, algo salió mal</h3>
                <p>
                 La página que estás buscando podría haber sido eliminada, haber cambiado de nombre o no está disponible temporalmente.
                </p>
                <Link className="btn app-store-btn" to="/">
                  Regresar al Inicio
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
